// Widget Scripts
import headerButtons from './js/widgets/headerButtons.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import manualFeed from './js/widgets/manualFeed.js';
import mainCards from './js/widgets/mainCards.js';
import * as seoStats from './js/widgets/seo-statics/index.js';
import * as videoSignup from './js/widgets/video-signup/index.js';
import * as sponsors from './js/widgets/sponsors-section/index.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  headerButtons();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    manualFeed();
    mainCards();
    seoStats.seoWidget();
    seoStats.statsWidget();

    $(globalThis).load(function () {
      videoSignup.videoWidget();
    });

    videoSignup.customSignup();
    sponsors.premiumSponsors();
    sponsors.scrollerSponsors();
  }
});
